<ng-container *ngIf="hours?.length; else noHours">
  <div class="col-row">
    <span class="col-label mr-1">Site hrs</span>
    <ng-container *ngIf="scheduledDayHours as sh">
      <span class="col-times" *ngIf="!isSiteClosed(sh) && !isHoursUnspecified(sh)">
        {{ minutesToTimeString(sh.open) }}<span class="dash">–</span
        >{{ minutesToTimeString(sh.close) }}
      </span>
      <span class="col-value col-value--closed" *ngIf="isSiteClosed(sh)">Closed</span>
      <span class="col-value col-value--closed" *ngIf="isHoursUnspecified(sh)">Unspecified</span>
    </ng-container>
    <span class="col-value col-value--closed" *ngIf="!scheduledDayHours">Unspecified</span>
    <button
      *ngIf="hasExpandableHours"
      class="col-all-days-btn"
      (click)="showAll = !showAll"
      [class.col-all-days-btn--open]="showAll"
      title="All days"
    >
      <i class="fa fa-chevron-down"></i>
    </button>
  </div>
  <ng-container *ngIf="showAll">
    <div
      class="col-row col-row--day"
      [class.col-row--today]="h.dayOfWeek === scheduledDayOfWeek"
      *ngFor="let h of hours"
    >
      <span class="col-label col-label--day">{{ weekdayName(h.dayOfWeek) }}</span>
      <span class="col-times" *ngIf="!isSiteClosed(h) && !isHoursUnspecified(h)"
        >{{ minutesToTimeString(h.open) }}<span class="dash">–</span
        >{{ minutesToTimeString(h.close) }}</span
      >
      <span class="col-value col-value--closed" *ngIf="isSiteClosed(h)">Closed</span>
      <span class="col-value col-value--closed" *ngIf="isHoursUnspecified(h)">Unspecified</span>
    </div>
  </ng-container>
</ng-container>
<ng-template #noHours>
  <div class="col-row">
    <span class="col-label">Site hrs</span>
    <span class="col-value col-value--closed">Unspecified</span>
  </div>
</ng-template>
